const caches = new Map();
const pending = new Set();
const PREFIX = 'course-access:';

function timestamp(value) {
  if (!value) return 0;
  const result = typeof value === 'number' ? value : Date.parse(value);
  return Number.isFinite(result) && result > 0 ? result : 0;
}

function read(userId) {
  if (!userId) return {};
  const key = String(userId);
  if (!caches.has(key)) {
    let entries = {};
    try {
      const parsed = JSON.parse(localStorage.getItem(PREFIX + key) || '{}');
      if (parsed && typeof parsed === 'object' && !Array.isArray(parsed)) {
        entries = Object.fromEntries(Object.entries(parsed).filter(([, value]) => timestamp(value)));
      }
    } catch { /* Storage may be unavailable in a private WebView. Use memory. */ }
    caches.set(key, entries);
  }
  return caches.get(key);
}

export function rememberCourseAccess(userId, courseId, accessedAt = Date.now()) {
  if (!userId || !courseId || !timestamp(accessedAt)) return;
  const previous = read(userId);
  const entries = { ...previous, [String(courseId)]: Math.max(timestamp(previous[String(courseId)]), timestamp(accessedAt)) };
  const bounded = Object.fromEntries(Object.entries(entries).sort((a, b) => b[1] - a[1]).slice(0, 250));
  caches.set(String(userId), bounded);
  try { localStorage.setItem(PREFIX + String(userId), JSON.stringify(bounded)); }
  catch { /* Server persistence remains authoritative; memory supports Back. */ }
}

export function courseAccessTime(course, userId) {
  const id = String(course.id || course._id || '');
  return Math.max(timestamp(course.lastAccessedAt), timestamp(read(userId)[id]));
}

export function compareCourseRecency(a, b, userId) {
  return courseAccessTime(b, userId) - courseAccessTime(a, userId);
}

export function trackCourseAccessWrite(_key, promise) {
  pending.add(promise);
  const clear = () => pending.delete(promise);
  promise.then(clear, clear);
  return promise;
}

// Wait for small in-flight access writes before fetching a server-paginated list.
// Each write has its own short HTTP timeout; failures never prevent list loading.
export async function waitForCourseAccessWrites() {
  await Promise.allSettled([...pending]);
}